import React from 'react';
import PropTypes from 'prop-types';
import css from './CancelDescription.css';

export default class CancelDescription extends React.Component {
  render() {
    return (
      <div className={css['container']}>
        <p>You can add a message explaining why you need to cancel:</p>
        <textarea value={this.props.value} onChange={this.props.onChange}></textarea>
      </div>
    )
  }
}

CancelDescription.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}
